import {atom} from 'recoil';

export const reloadRfpsState = atom({
  key: 'reloadRfpsState',
  default: false,
});
